import axios, { AxiosResponse } from 'axios'
import * as _ from 'lodash-es'

import { StoreResidencyId } from '@/modules/residency/stores/ResidencyStore'

import { ResidencyId, ResidencyPublicRead, ResidencyRead, ResidencyWrite } from '@generated/types'

const BASE_URL = '/api/residency'

export default {
  async create(residency: ResidencyWrite): Promise<AxiosResponse<ResidencyRead>> {
    return axios.post(
      `${BASE_URL}/`,
      _.pick(residency, [
        'name',
        'description',
        'tagline',
        'intro',
        'social_proof',
        'show_id',
        'performance_ids',
        'video_url',
        'external_links',
      ]),
    )
  },

  async fetchAll(query?: string): Promise<AxiosResponse<ResidencyRead[]>> {
    const config = query ? { params: { q: query } } : undefined
    return axios.get(`${BASE_URL}/`, config)
  },

  async update(residency: ResidencyWrite): Promise<AxiosResponse<ResidencyRead>> {
    // Ensure residency.id exists before using it in the URL
    if (residency.id === undefined || residency.id === null) {
      return Promise.reject(new Error('Residency ID is required for update.'))
    }
    return axios.put(
      `${BASE_URL}/${residency.id}/`,
      _.pick(residency, [
        'id',
        'name',
        'description',
        'tagline',
        'intro',
        'social_proof',
        'show_id',
        'performance_ids',
        'invite_codes',
        'video_url',
        'external_links',
      ]),
    )
  },

  async delete(id: StoreResidencyId): Promise<AxiosResponse> {
    return axios.delete(`${BASE_URL}/${id}/`)
  },

  async fetchOnePublic(id: ResidencyId | string): Promise<AxiosResponse<ResidencyPublicRead>> {
    return axios.get(`${BASE_URL}/${id}/`)
  },
}
